var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 14C1.55228 14 2 14.4477 2 15V18C2 18.2652 2.10536 18.5196 2.29289 18.7071C2.48043 18.8946 2.73478 19 3 19H17C17.2652 19 17.5196 18.8946 17.7071 18.7071C17.8946 18.5196 18 18.2652 18 18V15C18 14.4477 18.4477 14 19 14C19.5523 14 20 14.4477 20 15V18C20 18.7957 19.6839 19.5587 19.1213 20.1213C18.5587 20.6839 17.7957 21 17 21H3C2.20435 21 1.44129 20.6839 0.87868 20.1213C0.31607 19.5587 0 18.7956 0 18V15C0 14.4477 0.447715 14 1 14Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7071 5.70711C14.3166 6.09763 13.6834 6.09763 13.2929 5.70711L10 2.41421L6.70711 5.70711C6.31658 6.09763 5.68342 6.09763 5.29289 5.70711C4.90237 5.31658 4.90237 4.68342 5.29289 4.29289L9.29289 0.292893C9.68342 -0.0976311 10.3166 -0.0976311 10.7071 0.292893L14.7071 4.29289C15.0976 4.68342 15.0976 5.31658 14.7071 5.70711Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16C9.44772 16 9 15.5523 9 15L9 1C9 0.447715 9.44772 5.62185e-08 10 7.93625e-09C10.5523 -4.0346e-08 11 0.447715 11 1L11 15C11 15.5523 10.5523 16 10 16Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.e99736e7898ef65e95499bf30c76bac7.svg";
export { ForwardRef as ReactComponent };